var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavBundles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.337 21.9942V17.6982C16.3371 16.6082 16.5856 15.5324 17.0636 14.5522C17.5417 13.572 18.2369 12.713 19.0966 12.04V12.04C19.9568 11.3661 20.6521 10.5061 21.1302 9.52486C21.6083 8.54365 21.8565 7.46692 21.8562 6.376V3.09856C21.8562 2.54199 21.6345 2.00821 21.2399 1.61465C20.8453 1.2211 20.3101 1 19.7521 1H6.79352C6.51705 0.999749 6.24323 1.05384 5.98773 1.15919C5.73223 1.26454 5.50004 1.41908 5.30446 1.61398C5.10887 1.80887 4.95371 2.0403 4.84785 2.29503C4.74199 2.54977 4.6875 2.82281 4.6875 3.09856V6.376C4.6872 7.46692 4.93545 8.54365 5.41351 9.52486C5.89157 10.5061 6.58693 11.3661 7.44708 12.04V12.04C8.30761 12.7136 9.00324 13.5735 9.48134 14.5548C9.95943 15.5361 10.2075 16.613 10.2067 17.704V22",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68915 4.64819C4.20633 4.92892 3.7621 5.27098 3.36759 5.66579C0.982438 8.04563 0.865009 11.7887 3.11252 14.0274C4.84508 15.7554 7.48724 16.0827 9.69625 15.0402",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8573 4.31396C22.4437 4.58325 22.9775 4.95411 23.4339 5.40933C25.6776 7.64901 25.564 11.392 23.1779 13.768C21.4011 15.5402 18.8629 16.0567 16.7578 15.2781",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16406 21.9856H19.3882",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBundles);
export default __webpack_public_path__ + "static/media/nav-bundles.85191f414f8152b9ddd636dae287c39c.svg";
export { ForwardRef as ReactComponent };